type SidebarType = 'JOURNAL_ENTRY' | 'LEDGER_ACCOUNT';

const sidebarTypes = {
  JOURNAL_ENTRY: 'JOURNAL_ENTRY' as SidebarType,
  LEDGER_ACCOUNT: 'LEDGER_ACCOUNT' as SidebarType,
};

export default sidebarTypes;
